import { render, staticRenderFns } from "./domLegend.vue?vue&type=template&id=986e48d4&scoped=true&"
import script from "./domLegend.vue?vue&type=script&lang=js&"
export * from "./domLegend.vue?vue&type=script&lang=js&"
import style0 from "./domLegend.vue?vue&type=style&index=0&id=986e48d4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986e48d4",
  null
  
)

export default component.exports